import React from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import {
  sendDontShowExtensionNIPopup,
  setDontShowExtensionNIPopup,
} from '../../store/auth/auth.actions';

export const ExtensionNIPopup: React.FC = (): JSX.Element => {
  const { user, isAddInfoModalActive, onboardingModalActive } = useSelector(
    (state: RootState) => state.auth
  );

  const dispatch = useDispatch();

  const { search } = useLocation();

  const showPopupQuery = new URLSearchParams(search).get('show-warning-popup');

  const goToStore = () => {
    window.open(
      'https://chrome.google.com/webstore/detail/substratas-q-for-email/okeemaalpjcfeggfnahbeoagboahbbka',
      '_blank'
    );
  };

  const closeAndDontShowAgain = () => {
    if (user) {
      dispatch(sendDontShowExtensionNIPopup(user.orgId, user.userId));
    }
  };

  const closeForNow = () => {
    dispatch(setDontShowExtensionNIPopup(true));
  };

  const popupIsVisibleCheck =
    !showPopupQuery &&
    !isAddInfoModalActive &&
    !onboardingModalActive &&
    !user?.isChromeExtensionInstalled &&
    user?.showInstallExtensionPopup;

  const attrs = {
    wrapper: {
      className: `${popupIsVisibleCheck ? 'open' : ''} not-installed`,
    },

    body: {
      wrapper: {
        className: 'not-installed__body',
      },

      closeIcon: {
        className: 'not-installed__body-close-icon',
        onClick: closeForNow,
      },

      title: {
        className: 'not-installed__body-title',
      },

      text: {
        className: 'not-installed__body-text',
      },

      button: {
        className: 'not-installed__body-button',
        onClick: goToStore,
      },

      dontShowAgain: {
        className: 'not-installed__body-dont-show-again',
        onClick: closeAndDontShowAgain,
      },
    },
  };

  const closeIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      {...attrs.body.closeIcon}
    >
      <path
        d="M2.10485 2.19355L2.14645 2.14645C2.32669 1.9662 2.6103 1.95234 2.80645 2.10485L2.85355 2.14645L6 5.2925L9.14645 2.14645C9.34171 1.95118 9.65829 1.95118 9.85355 2.14645C10.0488 2.34171 10.0488 2.65829 9.85355 2.85355L6.7075 6L9.85355 9.14645C10.0338 9.32669 10.0477 9.6103 9.89515 9.80645L9.85355 9.85355C9.67331 10.0338 9.3897 10.0477 9.19355 9.89515L9.14645 9.85355L6 6.7075L2.85355 9.85355C2.65829 10.0488 2.34171 10.0488 2.14645 9.85355C1.95118 9.65829 1.95118 9.34171 2.14645 9.14645L5.2925 6L2.14645 2.85355C1.9662 2.67331 1.95234 2.3897 2.10485 2.19355L2.14645 2.14645L2.10485 2.19355Z"
        fill="white"
      />
    </svg>
  );

  return (
    <div {...attrs.wrapper}>
      <div {...attrs.body.wrapper}>
        {closeIcon}
        <div {...attrs.body.title}>Chrome Extension Required</div>
        <div {...attrs.body.text}>
          Substrata Q for Google Workspace / Gmail requires you to{'\n'} install
          a Chrome Extension.
        </div>
        <div {...attrs.body.button}>Add to Chrome</div>
        <div {...attrs.body.dontShowAgain}>Don’t show again</div>
      </div>
    </div>
  );
};
